import { render, staticRenderFns } from "./infoCollection.vue?vue&type=template&id=7c0d0304"
import script from "./infoCollection.vue?vue&type=script&lang=js"
export * from "./infoCollection.vue?vue&type=script&lang=js"
import style0 from "./infoCollection.vue?vue&type=style&index=0&id=7c0d0304&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports